import { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function ResendDownloads() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/resend-download", { email, origin_url: window.location.origin });
    } catch {
      // same outcome either way — never reveal whether the email matched
    } finally {
      setSending(false);
      setDone(true);
    }
  };

  return (
    <div data-testid="resend-page" className="pt-20 min-h-screen bg-[#F8F5F0]">
      <section className="max-w-xl mx-auto px-6 py-24 sm:py-32 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-6">Lost Your Email?</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#4A3F35] mb-8">
          Resend My Downloads
        </h1>
        <div className="w-16 h-px bg-[#C6A769] mx-auto mb-10" />

        {done ? (
          <div data-testid="resend-confirmation" className="fade-up">
            <MailCheck className="w-12 h-12 text-[#C6A769] mx-auto" strokeWidth={1.2} />
            <p className="mt-6 text-base text-[#4A3F35]/70 leading-relaxed">
              If that email matches an order, a fresh download email with new links is on its way.
              Give it a few minutes and check your spam folder too.
            </p>
          </div>
        ) : (
          <>
            <p className="text-base text-[#4A3F35]/70 leading-relaxed mb-10">
              Enter the email address you purchased with and we'll send you a fresh
              copy of your download email — new links, valid for 30 days.
            </p>
            <form onSubmit={submit} className="space-y-5" data-testid="resend-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your purchase email"
                data-testid="resend-email-input"
                className="w-full bg-[#FAF7F2] border border-[#4A3F35]/15 rounded-sm px-5 py-4 text-sm text-[#4A3F35] placeholder:text-[#8A7D71]/60 outline-none focus:border-[#C6A769] transition-colors duration-300 text-center"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="resend-submit-button"
                className="w-full bg-[#C6A769] text-[#4A3F35] py-4 rounded-sm text-sm font-medium uppercase tracking-[0.18em] transition-all duration-300 hover:bg-[#B08F50] disabled:opacity-60 inline-flex items-center justify-center gap-2"
              >
                {sending ? (
                  <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</>
                ) : (
                  "Resend My Download Email"
                )}
              </button>
            </form>
          </>
        )}
      </section>
    </div>
  );
}
